import React from 'react';
import PropTypes from 'prop-types';

import "./sort-arrows.css";

const SortArrows = ({ name, sort, order }) => {

	return (
		<div className="sort-arrows">
			{order === true && name === sort && <span className="material-icons">keyboard_arrow_up</span>}
			{order === false && name === sort && <span className="material-icons">keyboard_arrow_down</span>}
		</div>
	);
};

SortArrows.propTypes = {
	name: PropTypes.string.isRequired,
	sort: PropTypes.string.isRequired,
	order: PropTypes.bool.isRequired,
}

export default SortArrows;


// WEBPACK FOOTER //
// ./src/components/common/files/filters/SortArrows/index.js